import { DataModelDetail } from '../settings/datamodel/datamodel.settings';
import { DataObjectDetail, DataObjectSettings } from '../settings/datamodel/dataobject/dataobject.settings';
import { DataSourceDetail } from '../settings/datamodel/datasource/datasource.settings';
import { GenericCDATAPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/generic.cdata.panel';
import { D365ConnectorPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/panels/d365/d365.connector.panel';
import { D365BusinessCentralConnectorPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/panels/d365businesscentral/d365businesscentral.connector.panel';
import { DynamicsNAVConnectorPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/panels/dynamicsnav/dynamicsnav.connector.panel';
import { GoogleAdsConnectorPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/panels/googleads/google.ads.connector.panel';
import { GoogleAnalyticsConnectorPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/panels/googleanalytics/google.analytics.connector.panel';
import { HaufeX360ConnectorPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/panels/haufeX360/haufeX360.connector.panel';
import { JIRAConnectorPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/panels/jira/jira.connector.panel';
import { JIRAServiceManagementConnectorPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/panels/jiraservicedesk/jiraservicedesk.connector.panel';
import { Office365ConnectorPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/panels/office365/office365.connector.panel';
import { SAPB1ConnectorPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/panels/sapb1/sapb1.connector.panel';
import { SAPERPConnectorPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/panels/saperp/saperp.connector.panel';
import { SAPGatewayConnectorPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/panels/sapgateway/sapgateway.connector.panel';
import { ShopifyConnectorPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/panels/shopify/shopify.connector.panel';
import { SnowflakeConnectorPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/panels/snowflake/snowflake.connector.panel';
import { ConnectorsPanel } from '../settings/datamodel/datasource/datasourcepanels/connectors/connectors.panel';
import { CouchBasePanel } from '../settings/datamodel/datasource/datasourcepanels/couchbase/couchbase.panel';
import { FirebirdPanel } from '../settings/datamodel/datasource/datasourcepanels/firebird/firebird.panel';
import { LiteDBPanel } from '../settings/datamodel/datasource/datasourcepanels/litedb/litedb.panel';
import { MSDBPanel } from '../settings/datamodel/datasource/datasourcepanels/mediasourcedb/msdb.panel';
import { MongoDBPanel } from '../settings/datamodel/datasource/datasourcepanels/mongodb/mongodb.panel';
import { MySQLDBPanel } from '../settings/datamodel/datasource/datasourcepanels/mysqldb/mysqldb.panel';
import { NoDBPanel } from '../settings/datamodel/datasource/datasourcepanels/nodatabase/nodatabase.panel';
import { ODBCDBPanel } from '../settings/datamodel/datasource/datasourcepanels/odbcdb/odbcdb.panel';
import { PostgreSQLPanel } from '../settings/datamodel/datasource/datasourcepanels/postgredb/postgredb.panel';
import { SQLDBPanel } from '../settings/datamodel/datasource/datasourcepanels/sqldb/sqldb.panel';
import { ContainerEnumDetail, ContainerEnumSettings } from '../settings/datamodel/enum/containerenum.settings';
import { MediaSourceDetail, MediaSourceSettings } from '../settings/datamodel/mediasource/mediasource.settings';
import { OdooConnectorPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/panels/odoo/odoo.connector.panel';
import { MSAccessConnectorPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/panels/msaccess/msaccess.connector.panel';
import { DB2ConnectorPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/panels/db2/db2.connector.panel';
import { HubSpotConnectorPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/panels/hubspot/hubspot.connector.panel';
import { GraphQLConnectorPanel } from '../settings/datamodel/datasource/datasourcepanels/cdata/panels/graphql/graphql.connector.panel';

export const APP_DATAMODEL = [
    DataModelDetail,
    DataSourceDetail,
    LiteDBPanel,
    MongoDBPanel,
    PostgreSQLPanel,
    SQLDBPanel,
    MediaSourceSettings,
    MediaSourceDetail,
    DataObjectSettings,
    DataObjectDetail,
    ContainerEnumSettings,
    ContainerEnumDetail,
    MySQLDBPanel,
    ODBCDBPanel,
    CouchBasePanel,
    MSDBPanel,
    NoDBPanel,
    ConnectorsPanel,
    GenericCDATAPanel,
    FirebirdPanel
];

export const APP_CDATA_CONNECTORS = [
    D365ConnectorPanel,
    HaufeX360ConnectorPanel,
    Office365ConnectorPanel,
    SAPB1ConnectorPanel,
    DynamicsNAVConnectorPanel,
    SAPGatewayConnectorPanel,
    D365BusinessCentralConnectorPanel,
    SAPERPConnectorPanel,
    JIRAConnectorPanel,
    JIRAServiceManagementConnectorPanel,
    ShopifyConnectorPanel,
    SnowflakeConnectorPanel,
    GoogleAdsConnectorPanel,
    GoogleAnalyticsConnectorPanel,
    OdooConnectorPanel,
    MSAccessConnectorPanel,
    DB2ConnectorPanel,
    HubSpotConnectorPanel,
    GraphQLConnectorPanel
];
